import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client';

const FETCH_ADRIATIC = gql`
    query adriaticFeed($sku: String!) {
        adriaticFeed(sku: $sku)
    }
`;

const adriaticEnabledBrands = ['WHIRLPOOL'];

const Adriatic = ({ brand, sku, setHasFeed }) => {
    const isEnabledBrand = brand && adriaticEnabledBrands.includes(brand);

    const { data, loading, error } = useQuery(FETCH_ADRIATIC, {
        fetchPolicy: 'cache-first',
        variables: { sku },
        skip: !isEnabledBrand || !sku, // Pomijamy zapytanie, jeśli marka nie jest włączona lub brak sku
    });

    // Ustawiamy flagę setHasFeed, gdy dane są dostępne
    const html = data?.adriaticFeed || '';
    React.useEffect(() => {
        if (html) {
            setHasFeed(true);
        }
    }, [html, setHasFeed]);

    if (!isEnabledBrand || !sku) return null;
    if (loading) return <div>Loading...</div>; // Placeholder podczas ładowania
    if (error) return null; // Możesz dodać komunikat błędu, np. <div>Error: {error.message}</div>

    return <div dangerouslySetInnerHTML={{ __html: html }} />;
};

Adriatic.propTypes = {
    brand: PropTypes.string.isRequired,
    sku: PropTypes.string.isRequired,
    setHasFeed: PropTypes.func.isRequired,
};

export default memo(Adriatic);